// @flow
import { createAction, handleAction, type ActionType } from 'redux-actions'

export type RequestStatus = 'loading' | 'error' | 'success'

/**
 * Action for updating the request status
 */
export const requestStatusUpdate = createAction(
  'REQUEST_STATUS/UPDATE',
  (status: RequestStatus) => status
)

/**
 * Reducer for the request status
 */
export const requestStatus = handleAction(
  requestStatusUpdate,
  (state, { payload }: ActionType<typeof requestStatusUpdate>) => payload,
  'loading'
)



// WEBPACK FOOTER //
// ./src/components/loadingIndicator/reducer.js